import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { FAIcon } from "../core/components/faIcon";
import { ArticleEntity } from "./editArticle";
import React from "react";
export default class CalcPriceFieldOrigin extends React.Component<CalcPriceFieldOriginProps, CalcPriceFieldOriginState>{
    private _factory = ComponentHelper.createFactory();
 
    constructor(props: CalcPriceFieldOriginProps) {
        super(props)
        this.state = {
            value: props.value
        }
    }

    private onChange = (value: number) => {
        this.setState({ value: value }, () => { this.props.onChange(this.props.field, this.state.value); })
    }

    private showCalculateButton = () => {
        return !this.props.entity.IsNew && !this.props.disabled && this.props.field.calcButtonEnabled === true;
    }

    private createNumericTextBox = () => {

            let props = this._factory.getDefaultNumericTextBoxProps();
            props.value = this.state.value;
            props.disabled = this.props.field.readOnly;
        if (Helper.hasValue(this.props.field.min))
            props.field.min = this.props.field.min;
        if (Helper.hasValue(this.props.field.max))
            props.field.max = this.props.field.max;
        if (Helper.hasValue(this.props.field.format))
            props.field.format = this.props.field.format;
        if (Helper.hasValue(this.props.required))
            props.field.required = this.props.required;
        if (Helper.hasValue(this.props.field.spinners))
            props.field.spinners = this.props.field.spinners;
        if (Helper.hasValue(this.props.field.decimals))
            props.field.decimals = this.props.field.decimals;
        props.onChange = (field, value) => {
                this.onChange(value);
            }
            return (
                <div style={{ width: "100%" }}>
                    <IsNumericTextBox {...props} />
                    {this.createInfoText()}
                </div>
            );
    }

    private createInfoText = () => {
        let infoText = null;
        if (!Helper.isNullOrEmpty(this.props.field.infoText)) {
            let text: string = this.props.handleEval(this.props.field.infoText);
            let color = null;
            if (!Helper.isNullOrEmpty(text)) {
                if (!Helper.isNullOrEmpty(this.props.field.infoTextColor)) {
                    if (this.props.field.infoTextColor.startsWith('#'))
                        color = this.props.field.infoTextColor
                    else
                        color = this.props.handleEval(this.props.field.infoTextColor);
                }
            }
            if (color)
                infoText = (<div style={{marginLeft: "3px", margin: "2px"}}><span style={{color: color}}>{text}</span></div>)
            else
                infoText = (<div style={{marginLeft: "3px", margin: "2px"}}><span>{text}</span></div>);
        }

        return infoText;
    }
    private _getEvalValue(field_val: any) {
        if (Helper.hasValue(field_val))
            return (typeof (field_val) === "string") ? this.props.handleEval(field_val as string) : field_val;
        else
            return false;
    }

    private _execCustomFunction = () => {
        this.props.handleEval(this.props.field.calcButtonFunction);
    }
    private createCalcButton() {
        let customButton = null;
        if (this._getEvalValue(this.props.field.calcButtonEnabled)) {
            const iconName = Helper.isNullOrEmpty(this.props.field.calcButtonIcon) ? "reply" : this.props.field.calcButtonIcon;
            customButton = (
                <div data-role="button" key={kendo.guid()} onClick={this._execCustomFunction} style={{}} title={this.props.field.calcButtonTitle}>
                    <FAIcon name={iconName} attributes={[""]}/>
                </div>
            );
        }
        return customButton;
    }

    componentDidUpdate(prevProps: CalcPriceFieldOriginProps) {
        if (this.props.value != this.state.value) {
            this.setState({ value: this.props.value })
        }
    }

    render() {
        return (
            <div style={{ display: "flex" }} className="calc-price-field" data-show-button={this.showCalculateButton()} >
                {this.createNumericTextBox()}
                {this.createCalcButton()}
            </div>
        );
    }
}

interface CalcPriceFieldOriginProps {
    handleEval(action: string, prepare?: any);
    onChange: (field, value) => void;
    field: {
        model: string;

        readOnly: boolean;
        
        infoText?: string;
        infoTextColor?: string;

        format?: string;
        min?: number;
        max?: number;
        spinners?: boolean;
        decimals?: number;

        calcButtonEnabled?: boolean;
        calcButtonReadOnly?: boolean | string;
        calcButtonTitle?: string;
        calcButtonIcon?: string;
        calcButtonFunction?: string;
    };
    entity: ArticleEntity;
    value: number;
    disabled: boolean;
    required?: boolean;
}

interface CalcPriceFieldOriginState {
    value: number;
}